import api from '@/api';

/**
 * 列表-指标组-可分页
 * @param {jixiaoType,groupName} params
 * @returns Promise
 */
export function getPerformanceList(params) {
  return api({
    url: '/jixiao/group',
    method: 'GET',
    params
  })
}

/**
 * 添加 - 指标组
 * @param {groupName, jixiaoType, remark, uuid} data
 * @returns
 */
export function postPerformanceGroup(data) {
  return api({
    url: '/jixiao/group',
    method: 'POST',
    data,
  })
}

/**
 * 编辑 - 指标组
 * @param {groupName, jixiaoType, remark, uuid} data
 * @returns
 */
export function putPerformanceGroup(data) {
  return api({
    url: '/jixiao/group',
    method: "PUT",
    data
  })
}

/**
 * 删除 - 指标组
 * @param {String} uuid
 * @returns
 */
export function deletePerformanceGroup(uuid) {
  return api({
    url: `/jixiao/group/${uuid}`,
    method: 'DELETE',
  })
}

/**
 * 列表 - 指标组 - 不分页
 * @param { groupName, jixiaoType } params
 * @returns
 */
export function getPerformanceListAll(params) {
  return api({
    url: '/jixiao/group/groupList',
    method: 'GET'
  })
}

/**
 * 列表 - 考核阶段 - 可分页
 * @param {page, size, stageName } params
 * @returns Promise
 */
export function getStageList(params) {
  return api({
    url: '/jixiao/stage',
    method: 'GET',
    params
  })
}

/**
 * 添加 - 考核阶段
 * @param {description, groupUuid, open, stageEndDate, stageName, stageStartDate  } params
 * @returns Promise
 */
export function postStageList(data) {
  return api({
    url: '/jixiao/stage',
    method: 'POST',
    data
  })
}

/**
 * 编辑 - 考核阶段
 * @param {description, groupUuid, open, stageEndDate, stageName, stageStartDate, uuid  } params
 * @returns Promise
 */
export function putStageList(data) {
  return api({
    url: '/jixiao/stage',
    method: 'PUT',
    data
  })
}

/**
 * 删除 - 考核阶段
 * @param {description, groupUuid, open, stageEndDate, stageName, stageStartDate, uuid  } params
 * @returns Promise
 */
export function deleteStageList(uuid) {
  return api({
    url: `/jixiao/stage/${uuid}`,
    method: 'DELETE'
  })
}

/**
 * 列表 - 考核阶段 - 不分页
 * @param { stageName } params
 * @returns
 */
export function getStageListAll(params) {
  return api({
    url: '/jixiao/stage/stageList',
    method: 'GET',
    params
  })
}

/**************** 绩效指标管理 ****************/
/**
 * 列表 - 指标 - 可分页
 * @param {*} params
 * @returns
 */
export function getTargetList(params) {
  return api({
    url: '/jixiao/target/targetPage',
    method: 'GET',
    params
  })
}

/**
 * 添加-绩效指标
 * @param {*} data
 * @returns
 */
export function postTarget(data)  {
  return api({
    url: '/jixiao/target/targetAdd',
    method: 'POST',
    data
  })
}

/**
 * 编辑-绩效指标
 * @param {*} data
 * @returns
 */
export function putTarget(data) {
  return api({
    url: '/jixiao/target/targetEdit',
    method: 'PUT',
    data
  })
}

/**
 * 添加-绩效指标量化
 * @param {*} data
 * @returns
 */
export function postTargetLable(data) {
  return api({
    url: '/jixiao/target/targetLableAdd',
    method: 'POST',
    data
  })
}

/**
 * 编辑-绩效指标量化
 * @param {*} data
 * @returns
 */
export function putTargetLable(data) {
  return api({
    url: '/jixiao/target/targetLableEdit',
    method: 'PUT',
    data
  })
}

/**
 * 删除-绩效指标量化
 * @param {*} data
 * @returns
 */
export function deleteTargetLable(uuid) {
  return api({
    url: `/jixiao/target/targetLableRemove/${uuid}`,
    method: 'DELETE',
  })
}

/**
 * 添加OR编辑-绩效指标量化
 * @param {*} data
 * @returns
 */
export function replaceTargetLable(data) {
  return api({
    url: '/jixiao/target/targetLableReplace',
    method: 'POST',
    data
  })
}

/**
 * 删除-绩效指标
 * @param {*} data
 * @returns
 */
export function deleteTarget(uuid) {
  return api({
    url: `/jixiao/target/targetRemove/${uuid}`,
    method: 'DELETE',
  })
}

/**
 * 添加二级指标
 * @param {*} data
 * @returns
 */
export function addSecondTarget(data) {
  return api({
    url: '/jixiao/target/targetSecondlyAdd',
    method: 'POST',
    data
  })
}

/**
 * 编辑-绩效二级指标
 * @param {*} data
 * @returns
 */
export function editSecondTarget(data) {
  return api({
    url: '/jixiao/target/targetSecondlyEdit',
    method: 'PUT',
    data
  })
}

/**
 * 删除-绩效二级指标
 * @param {*} uuid
 * @returns
 */
export function deleteSecondTarget(uuid) {
  return api({
    url: `/jixiao/target/targetSecondlyRemove/${uuid}`,
    method: 'DELETE',
  })
}

/**
 * 删除-绩效二级指标文件
 * @param {*} uuid
 * @returns
 */
export function deleteSecondTargetFile(uuid) {
  return api({
    url: `/jixiao/target/targetSecondlyFileRemove/${uuid}`,
    method: 'DELETE',
  })
}

/**
 * 列表-二级指标-GET-可分页
 * @param {*} params
 * @returns
 */
export function targetSecondList(params) {
  return api({
    url: '/jixiao/target/targetSecondlyPage',
    method: 'GET',
    params
  })
}

/* **************** 绩效指标提交管理 **************** */
/**
 * 列表-绩效指标提交-GET-可分页
 * @param {Object} params { groupUuid*, page, size, taretName }
 * @returns
 */
export function getTargetListForSubmit(params) {
  return api({
    url: '/jixiao/target/submit/getTargetSubmitList',
    method: 'GET',
    params
  })
}

/**
 * 删除-撤回提交的绩效
 * @param {*} uuid
 * @returns
 */
export function deleteTargetCompletedRevocation(uuid) {
  return api({
    url: `/jixiao/target/submit/targetCompletedRemove/${uuid}`,
    method: 'DELETE',
  })
}

/**
 * 添加-绩效指标提交
 * @param {Object} data  { fileFormList:[], targetSelfScoreForm }
 * @returns
 */
export function postTargetSubmit(data) {
  return api({
    url: '/jixiao/target/submit/targetSubmitAdd',
    method: 'POST',
    data
  })
}

/**
 * 完成-绩效全部提交
 * @param {*} data
 * @returns
 */
export function postTargetSumitAll(data) {
  return api({
    url: '/jixiao/target/submit/targetCompletedSubmit',
    method: "POST",
    data
  })
}

/**
 * 编辑-绩效指标提交
 * @param {Object} data
 * @returns
 */
export function putTargetSubmit(data) {
  return api({
    url: '/jixiao/target/submit/targetSubmitEdit',
    method: 'PUT',
    data
  })
}

/**
 * 添加-绩效指标文件提交
 * @param {Object} data
 * @returns
 */
export function postTargetFile(data) {
  return api({
    url: '/jixiao/target/submit/targetSubmitFileAdd',
    method: 'POST',
    data
  })
}

/**
 * 编辑-绩效指标文件提交
 * @param {*} data
 * @returns
 */
export function putTargetFileSubmit(data) {
  return api({
    url: '/jixiao/target/submit/targetSubmitFileEdit',
    method: 'PUT',
    data
  })
}

/**
 * 删除-绩效指标文件提交
 * @param {*} uuid
 * @returns
 */
export function deleteTargetSubmit(uuid) {
  return api({
    url: `/jixiao/target/submit/targetSubmitFileRemove/${uuid}`,
    method: 'DELETE',
  })
}

/**
 * 添加OR编辑-绩效指标文件提交
 * @param {*} data
 * @returns
 */
export function replaceTargetSubmit(data) {
  return api({
    url: '/jixiao/target/submit/targetSubmitFileReplace',
    method: 'POST',
    data
  })
}

/**
 * 列表-文件库考核阶段-GET-可分页
 * @param {*} params
 * @returns
 */
export function getLibraryStageList(params) {
  return api({
    url: '/jixiao/stage/getLibraryStagePage',
    method: 'GET',
    params
  })
}

/**
 * 列表-绩效指标提交-GET-可分页
 * @param {*} params
 * @returns
 */
export function getLibraryList(params) {
  return api({
    url: '/jixiao/target/library',
    method: 'GET',
    params
  })
}

/**
 * 列表-提交考核阶段-GET-可分页
 * @param {*} params
 * @returns
 */
export function getSubmitStagePage(params) {
  return api({
    url: '/jixiao/stage/getSubmitStagePage',
    method: "GET",
    params
  })
}


/* *************** 绩效指标审核管理 *************** */

/**
 * 批量下载考核指标文件(zip) system
 * @param {*} params
 * @returns
 */
export function downloadMutileFile(params) {
  return api({
    url: '/jixiao/target/audit/batchDownloadTargetFileZip',
    method: 'GET',
    params
  })
}

/**
 *
 * @param {*} params
 * @returns
 */
export function downloadTargetFileListForYouth(params) {
  return api({
    url: '/jixiao/target/library/batchDownloadTargetFileZip',
    method: 'GET',
    params
  })
}

/**
 * 列表-审核考核阶段-GET-可分页
 * @param {*} parmas
 * @returns
 */
export function getAuditStageList(params) {
  return api({
    url: '/jixiao/target/audit/getAuditStagePage',
    method: 'GET',
    params
  })
}
/**
 * 列表-审核考核阶段-GET-可分页 会员协会使用
 * @param {*} parmas
 * @returns
 */
export function getAuditStageListForOrg(params) {
  return api({
    url: '/jixiao/target/audit/getOrganAuditStagePage',
    method: 'GET',
    params
  })
}

/**
 * 获取待审核俱乐部列表-GET-可分页--系统管理员/技术支持调用
 * @param {*} params
 * @returns
 */
export function getAuditClubPage(params)  {
  return api({
    url: '/jixiao/target/audit/auditClubPage',
    method: 'GET',
    params
  })
}

/**
 * 获取待审核会员协会列表-GET-可分页--系统管理员/技术支持调用
 * @param {*} params
 * @returns
 */
export function getAuditOrgPage(params) {
  return api({
    url: '/jixiao/target/audit/auditOrganPage',
    method: 'GET',
    params
  })
}

/**
 *
获取待审核青训中心列表-GET-可分页--系统管理员/技术支持调用
 * @param {*} params
 * @returns
 */
export function getAuditYouthPage(params) {
  return api({
    url: '/jixiao/target/audit/auditYouthPage',
    method: 'GET',
    params
  })
}

export function getOrgAuditPage(params) {
  return api({
    url: '/jixiao/target/audit/OrganAuditYouthAndClubPage',
    method: 'GET',
    params
  })
}

/**
 * 列表-绩效指标审核-系统管理员-GET-可分页
 * @param {*} params
 * @returns
 */
export function getAuditList(params) {
  return api({
    url: '/jixiao/target/audit/getTargetAuditList',
    method: "GET",
    params,
  })
}

/**
 * 列表-绩效指标审核-会员协会-GET-列表
 * @param {*} params
 * @returns
 */
export function getOrgAuditList(params) {
  return api({
    url: '/jixiao/target/audit/getOrganTargetAuditList',
    method: "GET",
    params,
  })
}

/**
 * 添加-提交考核阶段机构审核日志-会员协会调用
 * @param {*} data
 * @returns
 */
export function orgAuditLogAdd(data) {
  return api({
    url: '/jixiao/target/audit/organAuditStageLogAdd',
    method: 'POST',
    data
  })
}
/**
 * 添加-绩效审核提交
 * @param {*} data
 * @returns
 */
export function postAuditTarget(data) {
  return api({
    url: "/jixiao/target/audit/targetAuditAdd",
    method: "POST",
    data
  })
}

/**
 * 编辑-绩效审核提交
 * @param {*} data
 * @returns
 */
export function putAuditTarget(data) {
  return api({
    url: '/jixiao/target/audit/targetAuditEdit',
    method: 'PUT',
    data
  })
}

/**
 * 添加OR编辑-绩效审核提交
 * @param {*} data
 * @returns
 */
export function replaceAuditTarget(data) {
  return api({
    url: '/jixiao/target/audit/targetAuditReplace',
    method: "POST",
    data
  })
}

/**
 * 添加-绩效二级审核提交
 * @param {*} data
 * @returns
 */
export function postSecondTargetAuditScore(data) {
  return api({
    url: '/jixiao/target/audit/targetSecondlyAuditAdd',
    method: 'POST',
    data
  })
}

/**
 * 编辑-绩效二级审核提交
 * @param {*} data
 * @returns
 */
export function putSecondTargetAuditScore(data) {
  return api({
    url: '/jixiao/target/audit/targetSecondlyAuditEdit',
    method: 'PUT',
    data
  })
}

/**
 * 编辑-绩效二级审核提交
 * @param {*} data
 * @returns
 */
export function replaceSecondTargetAuditScore(data) {
  return api({
    url: '/jixiao/target/audit/targetSecondlyAuditReplace',
    method: 'POST',
    data
  })
}

/**
 * 列表-获取文件与量化指标-GET-列表
 * @param {*} params
 * @returns
 */
export function getSecondTargetFileAndLabel(params) {
  return api({
    url: '/jixiao/target/submit/getTargetFileAndLableSubmitList',
    method: 'GET',
    params
  })
}

/**
 * 列表-获取二级指标内文件-GET-列表
 * @param {*} params
 * @returns
 */
export function getTargetFileList(params) {
  return api({
    url: '/jixiao/target/submit/getTargetSecondlyFileList',
    method: 'GET',
    params
  })
}
/**
 * 列表-获取二级指标内文件-GET-列表 专家
 * @param {*} params
 * @returns
 */
export function getTargetFileListExpert(params) {
  return api({
    url: '/jixiao/target/submit/getTargetSecondlyFileListExpert',
    method: 'GET',
    params
  })
}

/**
 * 列表-获取二级指标内量化指标-GET-列表
 * @param {*} params
 * @returns
 */
export function getTargetLabelList(params) {
  return api({
    url: '/jixiao/target/submit/getTargetSecondlyLableList',
    method: 'GET',
    params
  })
}

/**
 * 批量下载当前机构全部考核指标文件(zip)
 * @param {*} params
 * @returns
 */
export function getAllFiles(params) {
  const { youthUuid, stageUuid } = params;
  return api({
    url: `/jixiao/target/audit/batchDownloadTargetAllFileZip/${youthUuid}/${stageUuid}`,
    method: 'GET'
  })
}

/**
 * 下载当前机构考核指标文件
 * @param {*} params
 * @returns
 */
export function getAuditFiles(params) {
  return api({
    url: '/jixiao/target/audit/downloadOrganTargetAuditList',
    method: "GET",
    params,
  })
}


/**
 * 文件库批量下载考核指标文件(zip)
 * @param {*} params
 * @returns
 */
export function getAllFilesForLib(params) {
  const { stageUuid } = params;
  return api({
    url: `/jixiao/target/library/batchDownloadTargetAllFileZip/${stageUuid}`,
    method: 'GET',
  })
}

/**
 * 获取考核阶段类型与提交状态-GET
 * @returns
 */
export function getStageType(params) {
  return api({
    url: '/jixiao/target/submit/getStageInfo',
    method: 'GET',
    params,
  })
}

/**
 * 提交考核报名类型
 * @param {*} data
 * @returns
 */
export function postStageType(data) {
  return api({
    url: '/jixiao/target/submit/StageTypeAdd',
    method: 'POST',
    data
  })
}

/**
 * 获取绩效考核阶段机构审核日志-GET
 * @returns
 */
export function orgAuditStageInfo(params) {
  return api({
    url: '/jixiao/target/submit/getOrgAuditStageLog',
    method: 'GET',
    params
  })
}

/**
 * 添加OR编辑-排名设置-会员协会调用
 * @param {*} data
 * @returns
 */
export function putSortedOrg(data) {
  return api({
    url: '/jixiao/target/audit/organRankingReplace',
    method: 'POST',
    data
  })
}

/**
 * 添加OR删除推荐机构-会员协会调用
 * @param {*} data
 * @returns
 */
export function toggleOrgRecommend(data) {
  return api({
    url: '/jixiao/target/audit/organRecommendReplace',
    method: 'POST',
    data
  })
}

/**
 * shcadmin获取排名列表
 * @param {*} parrams
 * @returns
 */
export function loadUnSortYouthList(params) {
  return api({
    url: '/jixiao/target/audit/OrganAuditYouthAndClubList',
    method: 'GET',
    params,
  })
}

/**
 * shcadmin获取排名列表
 * @param {*} parrams
 * @returns
 */
export function loadUnSortYouthListForAdmin(params) {
  return api({
    url: '/jixiao/target/audit/auditYouthList',
    method: 'GET',
    params,
  })
}

/**
 * shcadmin撤回机构提交
 * @param {*} parrams
 * @returns
 */
export function auditStageLogDeleted(params) {
  const { uuid } = params;
  return api({
    url: `/jixiao/target/audit/adminAuditStageLogDeleted/${uuid}`,
    method: 'DELETE'
  })
}

/**
 * shcadmin提交审核结果
 * @param {*} parrams
 * @returns
 */
export function auditResultAdd(data) {
  return api({
    url: '/jixiao/target/audit/auditResultAdd',
    method: 'POST',
    data
  })
}

export function experToYouthAuditData(youthUuid,stageUuid) {
  return api({
    url:  `/expertToYouth/experToYouthAuditData/${youthUuid}/${stageUuid}`,
    method: 'GET',
  })
}
export function experToYouthAuditSave(data) {
  return api({
    url: '/expertToYouth/experToYouthAuditSave',
    method: 'POST',
    data
  })
}

export function uploadBaseScoreFile(data) {
  return api({
    url: '/jixiao/target/audit/uploadBaseScoreFile',
    method: 'POST',
    data
  })
}

export function baseScoreFileList(youthUuid,stageUuid) {
  return api({
    url:  `/jixiao/target/audit/baseScoreFileList/${youthUuid}/${stageUuid}`,
    method: 'GET',
  })
}
export function baseScoreFileListSummary(stageUuid) {
  return api({
    url:  `/jixiao/target/audit/baseScoreFileListSummary/${stageUuid}`,
    method: 'GET',
  })
}

export function downloadBaseScoreFile(youthUuid,stageUuid) {
  return api({
    url:  `/jixiao/target/audit/downloadBaseScoreFile/${youthUuid}/${stageUuid}`,
    method: 'GET',
  })
}
export function downloadBaseScoreSummaryFile(stageUuid) {
  return api({
    url:  `/jixiao/target/audit/downloadBaseScoreSummaryFile/${stageUuid}`,
    method: 'GET',
  })
}
export function baseScoreInfo(stageUuid) {
  return api({
    url:  `/jixiao/target/audit/baseScoreInfo/${stageUuid}`,
    method: 'GET',
  })
}
export function stageInfo(stageUuid) {
  return api({
    url:  `/jixiao/stage/stageInfo/${stageUuid}`,
    method: 'GET',
  })
}
